import { forwardRef, type Ref, type SVGProps } from "react";
const IconCalculatorOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 4v24H6V4zm0-2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"
    />
    <path
      fill="currentColor"
      d="M22 8v3H10V8zm1.5-2h-15a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5M11 16H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m6 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m0 4h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m6-4h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-12 4H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m12 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-6 4h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-6 0H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m12 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCalculatorOutlineSVG);
ForwardRef.displayName = "IconCalculatorOutline";
export { ForwardRef as IconCalculatorOutline };
